import './css/index.css';
import 'components/breadcrumbs';
import 'components/landing-intro';
import 'components/card-article';
import 'components/card-data-sub-section';
import 'components/card-event';
import 'components/card-featured-data';
import 'components/card-quarter-key-role';
import 'components/group-cards-mini-expert';
import 'components/group-cards-mini-research';
import 'components/strip-callout';
import 'components/footer';
import 'components/notification';
import 'components/featured-promo';
import Mediator from 'js/mediator';
import Navigation from 'components/navigation';

Mediator.create( {

    componentClasses: [
        Navigation
    ],

    init() {

        console.info( 'The Section Landing Page has initiated.' );

    },

    ready() {

        console.info( 'The Section Landing Page is ready.' );

        console.info( 'Components:', this.components );

    }

} );
